import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { createJpdExperience } from '../../utils/experience/main.tsx';

export const loadChildIssues = createJpdExperience(
	new UFOExperience('jpd.delivery-items.load.childIssues', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadAggregatedDeliveryProgressBasedOnProjectId = createJpdExperience(
	new UFOExperience('jpd.delivery-items.load.aggregatedDeliveryProgressBasedOnProjectId', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadAggregatedDeliveryProgress = createJpdExperience(
	new UFOExperience('jpd.delivery-items.load.aggregatedDeliveryProgress', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadLinkedDeliveryTickets = createJpdExperience(
	new UFOExperience('jpd.delivery-items.load.linkedDeliveryTickets', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadTransitiveChildrenArjHierarchy = createJpdExperience(
	new UFOExperience('jpd.delivery-items.load.transitiveChildrenArjHierarchy', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadTransitiveChildrenInTwoLevelCoreHierarchy = createJpdExperience(
	new UFOExperience('jpd.delivery-items.load.transitiveChildrenInTwoLevelCoreHierarchy', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);
